import { FieldValues, UseFieldArrayAppend } from 'react-hook-form';

import { AddFieldButton } from '@kanda-libs/ks-component-ts';

import { BASE_EXPENSE } from './constants';

export interface AddExpenseItemButtonProps {
  append: UseFieldArrayAppend<FieldValues, string>;
}

const AddExpenseItemButton: React.FunctionComponent<AddExpenseItemButtonProps> =
  function ({ append }) {
    return (
      <div className="mx-auto border border-dashed border-neutral-300 rounded-lg justify-center pt-3 px-4 mb-5 mt-2">
        <AddFieldButton
          label="Add additional expense information"
          onClick={() => append(BASE_EXPENSE)}
        />
      </div>
    );
  };

export default AddExpenseItemButton;
